import Configuracao from '../misc/Configuracao';
import { ControleGabinete } from "../modelo";
import { ControleGabineteDto } from './dto/ControleGabineteDto';
import fetch from './AxiosAdapter';
import { apresentarApiErroPadrao } from '@/utils/ApiErroPadraoUtils';

class ControleGabineteApi {
    private extrairErroParaPropagacao = (erro: any): any => {
        return erro?.response?.data || erro;
    }

    //TODO retirar as any
    //MANTEM
    async salvarKanban(gabinete: string, cards: ControleGabinete): Promise<any> {
        let result;
        try {
            result = await fetch(Configuracao.urlControlesGabineteGE + gabinete,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: cards
                });
            if (result.status >= 400) {
                if (apresentarApiErroPadrao(result?.data)) {
                    throw result.data;
                }
                const erro = result.data;
                throw new Error(erro ? erro.mensagem : null);
            }
        } catch (erro) {
            if (apresentarApiErroPadrao(erro)) {
                throw erro;
            }
            console.error("Não foi possível gravar o Controle de Gabinete. " + erro + " " + (result ? result.statusText : ""));
            throw new Error("Não foi possível gravar o Controle de Gabinete. " + erro + " " + (result ? result.statusText : ""));
        }
        return result;
    }

    //MANTEM
    async getKanban(gabinete: string): Promise<ControleGabineteDto[]> {
        const result = await fetch<ControleGabineteDto[]>(Configuracao.urlControlesGabineteGE + gabinete, {
            timeout: 15000
        });
        const controles = result.data;
        return controles;
    }

    async criarControlesGabinete(gabinete: string): Promise<ControleGabineteDto[]> {
        const result = await fetch<ControleGabineteDto[]>(Configuracao.urlControlesGabineteGE + gabinete + '/criar-controles-padrao',
            { method: 'POST' }
        );
        return result.data;
    }

    async criarControlesGabineteRedator(gabinete: string): Promise<ControleGabineteDto[]> {
        const result = await fetch<ControleGabineteDto[]>(Configuracao.urlControlesGabineteGE + gabinete + '/criar-controle-redator');
        return result.data;
    }

    async enviarParaPauta(
        identificadorProcesso: number,
        orgaoJulgador: string,
        silenciarNotificacaoDeErro: boolean = false,
        signal?: AbortSignal
    ) {
        let result;
        try {
            result = await fetch(Configuracao.urlEnviarParaPauta.replace('{ID_PROCESSO}', identificadorProcesso.toString()).replace('{SIGLA_GABINETE}', orgaoJulgador),
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    silent: silenciarNotificacaoDeErro,
                    signal
                });

            if (result.status >= 400) {
                console.error("Erro no visto a pauta", result)
                if (!silenciarNotificacaoDeErro && apresentarApiErroPadrao(result?.data)) {
                    throw result.data;
                }
                const erro = result.data;
                if (silenciarNotificacaoDeErro) {
                    throw erro;
                }
                throw new Error(erro ? erro.reason : null);
            }
            return result;
        } catch (erro) {
            if (!silenciarNotificacaoDeErro && apresentarApiErroPadrao(erro)) {
                throw erro;
            }
            if (silenciarNotificacaoDeErro) {
                throw this.extrairErroParaPropagacao(erro);
            }
            console.error(erro);
            console.error("Não foi possível realizar a operação. " + erro + " " + (erro?.response?.data?.reason));
            throw new Error("Não foi possível realizar a operação. " + erro + " " + (erro?.response?.data?.reason));
        }
    }

    async enviarAptoJulgamento(identificadorProcesso, orgaoJulgador) {
        let result;
        try {
            result = await fetch(Configuracao.urlProcessosGE + identificadorProcesso + '/' + orgaoJulgador + '/enviarAptoJulgamento',
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                });

            if (result.status >= 400) {
                if (apresentarApiErroPadrao(result?.data)) {
                    throw result.data;
                }
                const erro = result.data;
                throw new Error(erro ? erro.mensagem : null);
            }
            return result;
        } catch (erro) {
            if (apresentarApiErroPadrao(erro)) {
                throw erro;
            }
            console.error("Não foi possível realizar a operação. " + erro + " " + (result ? result.statusText : ""));
            throw new Error("Não foi possível realizar a operação. " + erro + " " + (result ? result.statusText : ""));
        }
    }

    async getTiposControles() {
        const result = await fetch(Configuracao.urlTiposControlesGabinete);
        return result.data;
    }
}

export default new ControleGabineteApi();
